import first from "lodash/first";
import last from "lodash/last";
import reduce from "lodash/reduce";
import sortBy from "lodash/sortBy";
import { useNavigate } from "react-router-dom";

import { RightOutlined } from "@ant-design/icons";
import { Button, Statistic } from "antd";

import { ActivityCountPie } from "components/activity-count-pie";
import { InitialActivity } from "./initial-activity";
import { LatestActivity } from "./latest-activity";
import { NextFollowup } from "./next-followup";
import { ScheduleNextFollowup } from "./schedule-next-followup";

import { useAccountCounts } from "../../../data/use-accounts";
import { useAccountActivities } from "../../../data/use-activities";
import { useActivityTypes } from "../../../data/use-activity-types";
import { useAccountFollowups } from "../../../data/use-followups";
import {
  CREATE_ACCOUNT_FOLLOWUP_MODAL,
  PERFORM_ACCOUNT_ACTIVITY_MODAL,
  useLayoutStore,
} from "../../../stores/layout";

export const AccountSummary = (props) => {
  const { _id } = props;

  const navigate = useNavigate();

  const activities = useAccountActivities({ _id });
  const followups = useAccountFollowups({ _id });
  const activityTypes = useActivityTypes();
  const counts = useAccountCounts({ _id });

  const activityTypeGroups = reduce(
    activities,
    (accumulator, activity) => {
      if (!activity?.typeId) {
        return accumulator;
      }

      if (!accumulator[activity.typeId]) {
        const type = activityTypes.byId(activity.typeId);

        if (!type) {
          return accumulator;
        }

        accumulator[activity.typeId] = {
          _id: type._id,
          name: type.label,
          count: 0,
        };
      }

      accumulator[activity.typeId].count =
        accumulator[activity.typeId].count + 1;

      return accumulator;
    },
    {}
  );

  const activity = last(sortBy(activities, "performedOn"));
  const followup = first(sortBy(followups, "dueOn"));

  const showPerformActivity = () => {
    useLayoutStore.getState().open(PERFORM_ACCOUNT_ACTIVITY_MODAL, {
      accountId: _id,
    });
  };

  const showCreateFollowup = () => {
    useLayoutStore.getState().open(CREATE_ACCOUNT_FOLLOWUP_MODAL, {
      accountId: _id,
    });
  };

  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "48px",
        }}
      >
        {activities.length === 0 && (
          <Button
            onClick={() => navigate(`/accounts/${_id}`)}
            style={{ marginBottom: "16px", width: "100%", height: "36px" }}
          >
            Details
            <RightOutlined />
          </Button>
        )}
        <div style={{ marginBottom: "48px" }}>
          {!followup && (
            <ScheduleNextFollowup showCreateFollowup={showCreateFollowup} />
          )}
          {followup && <NextFollowup followup={followup} />}
          <Button
            onClick={showCreateFollowup}
            ghost
            type="primary"
            style={{ width: "100%", height: "36px", marginTop: "16px" }}
          >
            Schedule Followup
          </Button>
        </div>
        <div>
          {activity && <LatestActivity activity={activity} />}
          {!activity && (
            <InitialActivity showPerformActivity={showPerformActivity} />
          )}
          <Button
            ghost
            onClick={showPerformActivity}
            style={{ width: "100%", height: "36px", marginTop: "16px" }}
            type="primary"
          >
            Log Activity
          </Button>
        </div>
      </div>
      {activities.length > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            onClick={() => navigate(`/accounts/${_id}`)}
            style={{ marginBottom: "16px", width: "100%", height: "36px" }}
          >
            Details
            <RightOutlined />
          </Button>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Statistic
              title="Logged Activities"
              value={activities.length}
              style={{ marginBottom: "16px", marginRight: "16px" }}
            />
            <Statistic
              title="Total Opportunities"
              value={counts?.totalOpportunities || 0}
              style={{ marginBottom: "16px", marginRight: "16px" }}
            />
            <Statistic
              title="Won Opportunities"
              value={counts?.wonOpportunities || 0}
              style={{ marginBottom: "16px" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "18px",
            }}
          >
            <ActivityCountPie counts={Object.values(activityTypeGroups)} />
          </div>
        </div>
      )}
    </div>
  );
};
